var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "41px",
    viewBox: "0 0 42 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "148DA68B-A45A-4523-AF4B-20A0D53A8963") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 16,
    y: 0,
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.2%",
    y: "-4.2%",
    width: "112.5%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 28,
    cy: 12,
    r: 7.2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.9%",
    y: "-6.9%",
    width: "113.9%",
    height: "113.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.708635,20.4572099 L16.4572111,28.7085708 C15.8475965,29.3181854 15.8475965,30.3065369 16.4572097,30.91615 L16.5757514,31.0232967 C17.0661921,31.4233168 17.7430437,31.4805368 18.2868053,31.1949633 L18.3019998,31.1850687 L23.6397885,35.2979755 L23.7818428,35.4120573 C24.5560966,35.9895574 25.587455,36.0722673 26.4446574,35.6692065 L26.4949998,35.6430687 L29.9798338,38.3542515 L31.0639998,37.2700687 L32.5635357,38.7707911 L34.7711804,36.5639807 L33.2709998,35.0630687 L34.3547264,33.9794394 L31.6419998,30.4900687 L31.687647,30.3968363 C32.0933784,29.4855904 31.9568914,28.4024265 31.2807927,27.6185158 L27.1869998,22.3000687 L27.1947963,22.2868892 C27.5043335,21.6978386 27.4114724,20.9524694 26.9162129,20.4572099 C26.3065997,19.8475967 25.3182482,19.8475967 24.708635,20.4572099 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-2.7%",
    width: "105.3%",
    height: "110.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.70863503,4.45720987 L0.457211053,12.7085708 C-0.152403459,13.3181854 -0.152403459,14.3065369 0.457209703,14.91615 L0.575751414,15.0232967 C1.06619209,15.4233168 1.74304368,15.4805368 2.28680532,15.1949633 L2.30199983,15.1850687 L7.6397885,19.2979755 L7.78184285,19.4120573 C8.55609663,19.9895574 9.58745501,20.0722673 10.4446574,19.6692065 L10.4949998,19.6430687 L13.9798338,22.3542515 L15.0639998,21.2700687 L16.5635357,22.7707911 L18.7711804,20.5639807 L17.2709998,19.0630687 L18.3547264,17.9794394 L15.6419998,14.4900687 L15.687647,14.3968363 C16.0933784,13.4855904 15.9568914,12.4024265 15.2807927,11.6185158 L11.1869998,6.30006867 L11.1947963,6.28688919 C11.5043335,5.69783856 11.4114724,4.95246938 10.9162129,4.45720987 C10.3065997,3.84759671 9.31824819,3.84759671 8.70863503,4.45720987 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-8.0%",
    width: "105.3%",
    height: "110.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7006572,16.6004711 L17.2011282,15.1 L20.9517074,18.8505791 C21.3660584,19.2649302 21.3660584,19.9366992 20.9517074,20.3510502 C20.5373564,20.7654012 19.8655873,20.7654012 19.4512363,20.3510502 L15.7006572,16.6004711 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.7%",
    y: "-21.7%",
    width: "139.7%",
    height: "157.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,21.1011282 L12.6999041,19.6012242 L16.4510502,23.3518033 C16.8654012,23.7655873 16.8654012,24.4373564 16.4510502,24.8517074 C16.0366992,25.2660584 15.3649302,25.2660584 14.9505791,24.8517074 L11.2,21.1011282 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.7%",
    y: "-21.7%",
    width: "139.7%",
    height: "157.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-210.000000, -181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-138",
    transform: "translate(232.000000, 201.500000) scale(-1, 1) translate(-232.000000, -201.500000) translate(212.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E7EAF3",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 1,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 25.6,
    y1: 9.6,
    x2: 25.6,
    y2: 14.4,
    id: "Line-27",
    stroke: "#788999",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.4,
    y1: 9.6,
    x2: 30.4,
    y2: 14.4,
    id: "Line-27",
    stroke: "#788999",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#788999",
    fill: "#C5CCD7",
    fillRule: "nonzero",
    points: "33.6890309 33.9380108 29.9383888 37.6885899 26.5626596 35.0630648 31.0634428 30.5627856"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    points: "34.0640069 36.5639139 32.5635359 38.0638179 31.0630648 36.5639139 32.5635359 35.0634428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5626596,22.3111713 L18.3112343,30.5625966 C17.8968833,30.9769477 17.2251143,30.9769477 16.8107633,30.5625966 C16.3964122,30.1482456 16.3964122,29.4764766 16.8107633,29.0621256 L25.0621886,20.8107633 C25.4765396,20.3964122 26.1483086,20.3964122 26.5626596,20.8107633 C26.9769477,21.2250513 26.9769477,21.8968833 26.5626596,22.3111713",
    id: "Path",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7953778,30.8303467 L26.8306617,34.7956298 C26.0448626,35.5809248 24.7863116,35.6276079 23.9448835,34.9018478 L18.3112343,30.5628486 L26.5625966,22.3114233 L30.9021628,27.9450725 C31.6279229,28.7865636 31.5811768,30.0450516 30.7953778,30.8303467",
    id: "Path",
    stroke: "#788999",
    fill: "#C5CCD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(9.385590, 13.385396) scale(-1, -1) translate(-9.385590, -13.385396) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#788999",
    fill: "#C5CCD7",
    fillRule: "nonzero",
    points: "1.07497601 8.82580716 4.82561816 5.07522801 8.2013473 7.70075312 3.70050112 12.2010323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2013473,20.4525836 L16.4527726,12.2011583 C16.8671236,11.7868073 17.5388927,11.7868073 17.9532437,12.2011583 C18.3675947,12.6155093 18.3675947,13.2872783 17.9532437,13.7016294 L9.70181836,21.9530547 C9.28746734,22.3674057 8.61569831,22.3674057 8.2013473,21.9530547 C7.78705928,21.5387037 7.78705928,20.8668716 8.2013473,20.4525836",
    id: "Path",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96862913,11.9334713 L7.93334529,7.96818813 C8.71914432,7.1828931 9.97769537,7.1362101 10.8191234,7.86197013 L16.4527726,12.2009693 L8.2014103,20.4523946 L3.86184413,14.8187454 C3.1360841,13.9772544 3.1828301,12.7187663 3.96862913,11.9334713",
    id: "Path",
    stroke: "#788999",
    fill: "#C5CCD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-120",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-115",
    transform: "translate(0.500000, 0.500000)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-116",
    transform: "translate(0.700000, 0.700000)",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.72351064e-13 1.49990406 1.50047106 -3.63931107e-13 3.00094212 1.49990406 1.50047106 3.00037512"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-117",
    transform: "translate(11.200000, 11.100000)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plugIcon.97482892476b20c8c26915aa9bf8019d.svg";
export { ForwardRef as ReactComponent };